import { render } from "./updateStatusPeppolIdentifier.vue?vue&type=template&id=3c33fd06"
import script from "./updateStatusPeppolIdentifier.vue?vue&type=script&lang=js"
export * from "./updateStatusPeppolIdentifier.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__